import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  GET_EMPLOYEES_IN_PROPERTY,
  GET_PROPERTY_BY_ID,
  LIST_ALL_PROPERTIES_WITH_PAGINATION,
  MONTHLY_RENT_SUMMARY,
} from '../graphql/accommodation.query';
import {
  ALLOCATE_EMPLOYEE,
  CREATE_PROPERTY,
  REMOVE_PROPERTY,
  UPDATE_ALLOCATE_EMPLOYEE,
  UPDATE_PROPERTY,
} from '../graphql/accommodation.mutation';

@Injectable({
  providedIn: 'root',
})
export class AccommodationService {
  constructor(private apollo: Apollo) {}

  findAllPropertiesWithPagination(
    propertyPaginationInput: any
  ): Observable<any> {
    return this.apollo
      .use('hrms')
      .watchQuery<any>({
        query: LIST_ALL_PROPERTIES_WITH_PAGINATION,
        variables: {
          propertyPaginationInput,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.findAllPropertiesWithPagination || [])
      );
  }

  createProperty(createPropertyInput: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: CREATE_PROPERTY,
        variables: {
          createPropertyInput,
        },
      })
      .pipe(map((result: any) => result.data.createProperty || []));
  }

  getPropertyById(id: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .watchQuery<any>({
        query: GET_PROPERTY_BY_ID,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.property || []));
  }

  updateProperty(id: any, updatePropertyInput: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: UPDATE_PROPERTY,
        variables: {
          id,
          updatePropertyInput,
        },
      })
      .pipe(map((result: any) => result.data.updateProperty || []));
  }

  removeProperty(id: any): Observable<any> {
    return this.apollo.use('hrms').mutate({
      mutation: REMOVE_PROPERTY,
      variables: {
        id,
      },
    });
  }

  allocateEmployee(createEmployeeWithPropertyInput: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: ALLOCATE_EMPLOYEE,
        variables: {
          createEmployeeWithPropertyInput,
        },
      })
      .pipe(map((result: any) => result.data.allocateEmployeeToProperty || []));
  }

  getEmployeesInProperties(
    propertyEmployeesPaginationInput: any
  ): Observable<any> {
    return this.apollo
      .use('hrms')
      .watchQuery<any>({
        query: GET_EMPLOYEES_IN_PROPERTY,
        variables: {
          propertyEmployeesPaginationInput,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.getEmployeesInProperties || [])
      );
  }

  updateAllocatedEmployeee(
    updateEmployeeWithPropertyInput: any
  ): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: UPDATE_ALLOCATE_EMPLOYEE,
        variables: {
          updateEmployeeWithPropertyInput,
        },
      })
      .pipe(map((result: any) => result.data.updateEmployeeAllocation || []));
  }

  monthlyRentSummary(
    year: any,
    month: any,
    propertyId: any,
    employeeName: any
  ): Observable<any> {
    return this.apollo
      .use('hrms')
      .watchQuery<any>({
        query: MONTHLY_RENT_SUMMARY,
        variables: {
          year,
          month,
          propertyId,
          employeeName,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.monthlyRentSummary || [])
      );
  }
}
